"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebMenuItem = void 0;
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _styles = require("@material-ui/core/styles");
var _react = _interopRequireDefault(require("react"));
var _Typography = require("./Typography");
var _styles2 = require("@material-ui/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _pittaModules = require("@thingsw/pitta-modules");
var _excluded = ["startIcon", "endIcon", "children", "appIcon", "darkMode", "select", "adminProfile", "setting"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _styles.makeStyles)({
  root: {
    minWidth: 144,
    // ux-ui 디자인 변경으로 높이 변경
    minHeight: function minHeight(props) {
      return props.dense ? 40 : 48;
    },
    "&:hover": {
      backgroundColor: _pittaModules.LightColors.primary["6"]
    }
  },
  selectRoot: {
    // ux-ui프로젝트 디자인으로 padding추가 , 전체적용(Leehj)
    padding: "12px 16px"
  },
  darkRoot: {
    "&:hover": {
      backgroundColor: "".concat(_pittaModules.DarkColors.primary["7"], "26")
    }
  },
  adminProfileRoot: {
    margin: 4,
    borderRadius: 4,
    padding: "8px 10px",
    "&:hover": {
      backgroundColor: "".concat(_pittaModules.LightColors.primary["6"])
    },
    "&:first-child": {
      marginBottom: 8
    }
  },
  gutters: function gutters(props) {
    return props.dense ? {
      paddingLeft: 16,
      paddingRight: 16
    } : {
      paddingLeft: 32,
      paddingRight: 32
    };
  }
});
var useStartIconStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _objectSpread(_objectSpread({
      minWidth: theme.spacing(3)
    }, theme.direction === "rtl" ? {
      marginLeft: 8
    } : {
      marginRight: 8
    }), {}, {
      color: function color(props) {
        return props.darkMode ? _pittaModules.DarkColors.primary["1"] : _pittaModules.LightColors.primary["1"];
      },
      fontSize: "1.125rem",
      "& > svg": theme.direction === "rtl" ? {
        transform: "matrix(-1, 0, 0, 1, 0, 0)"
      } : {}
    })
  };
});
var useStartIconSettingStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _objectSpread(_objectSpread({
      minWidth: theme.spacing(3)
    }, theme.direction === "rtl" ? {
      marginLeft: 4
    } : {
      marginRight: 4
    }), {}, {
      color: function color(props) {
        return props.darkMode ? _pittaModules.DarkColors.primary["1"] : _pittaModules.LightColors.primary["1"];
      },
      fontSize: "1.125rem",
      "& > svg": theme.direction === "rtl" ? {
        transform: "matrix(-1, 0, 0, 1, 0, 0)"
      } : {}
    })
  };
});
var useEndIconStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      minWidth: theme.spacing(3),
      color: function color(props) {
        return props.darkMode ? _pittaModules.DarkColors.primary["1"] : _pittaModules.LightColors.primary["1"];
      },
      fontSize: "1.125rem",
      flexGrow: 1,
      justifyContent: "flex-end",
      "& > svg": theme.direction === "rtl" ? {
        transform: "matrix(-1, 0, 0, 1, 0, 0)"
      } : {}
    }
  };
});
var WebMenuItem = function WebMenuItem(props) {
  var _clsx;
  var classes = useStyle(props);
  var theme = (0, _styles2.useTheme)();
  var startIconClasses = useStartIconStyle(props);
  var startIconSettingClasses = useStartIconSettingStyle(props);
  var endIconClasses = useEndIconStyle(props);
  var startIcon = props.startIcon,
    endIcon = props.endIcon,
    children = props.children,
    appIcon = props.appIcon,
    darkMode = props.darkMode,
    select = props.select,
    adminProfile = props.adminProfile,
    setting = props.setting,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, _extends({
    dir: appIcon ? "" : theme.direction,
    classes: {
      root: (0, _clsx2.default)(classes.root, (_clsx = {}, _defineProperty(_clsx, classes.darkRoot, darkMode), _defineProperty(_clsx, classes.selectRoot, select), _defineProperty(_clsx, classes.adminProfileRoot, adminProfile), _clsx)),
      gutters: (0, _clsx2.default)(classes.gutters, props.gutterClassName)
    }
  }, restProps), startIcon && /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, {
    className: props.mobileStartIcons,
    classes: setting ? startIconSettingClasses : startIconClasses
  }, startIcon), children && /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Body"
  }, children), endIcon && /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, {
    classes: endIconClasses
  }, endIcon));
};
exports.WebMenuItem = WebMenuItem;